import { AbstractControl } from '@angular/forms';

export function RegonValidator(control: AbstractControl) {
  let regon = control.value;
  if (regon === null || regon === undefined || regon.length === 0) {
    // if regon is not present, dont send error, use Validators.required
    return null;
  }
  let weights;
  switch (regon.length) {
    case 0:
      return null;
    case 7:
      weights = new Array(2, 3, 4, 5, 6, 7);
      break;

    case 9:
      weights = new Array(8, 9, 2, 3, 4, 5, 6, 7);
      break;

    case 14:
      weights = new Array(2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8);
      break;

    default:
      return { validRegon: true };
  }
  let checksum: number = 0;
  // tslint:disable
  for (let i = 0; i < weights.length; i++) {
    checksum += weights[i] * regon[i];
  }
  let intControlNr = checksum % 11 % 10;
  if (intControlNr == (regon[regon.length - 1])) {
    // tslint:enable
    return null;
  }
  return { validRegon: true };

}
